module.exports = __webpack_public_path__ + "static/media/filter_3_white_18dp.d9fd80b2.svg";